import { Component, inject } from '@angular/core';
import { ActionResult } from '@ntap/core';
import { ConfirmationService } from 'primeng/api';
import { catchError, flatMap, Observable, Subject } from 'rxjs';
import { ItemsListActionComponent } from '../items-list-action/items-list-action.component';

@Component({
  selector: 'app-delete-items-list',
  templateUrl: '../../../shared/components/actions/common-action-template.html',
  styleUrls: ['./delete-items-list.component.scss']
})
export class DeleteItemsListComponent extends ItemsListActionComponent {
  private subject$ = new Subject<Observable<ActionResult>>();

  confirmationService = inject(ConfirmationService);

  protected override doExecute(): Observable<ActionResult> {
    this.confirmationService.confirm({
      message: 'Jeste li sigurni da želite obrisati označene objekte?',
      accept: () => {
        this.subject$.next(super.doExecute());
      }
    });
    return this.subject$.pipe(
      flatMap((p) => p),
      catchError((e) => {
        this.notificationService.error(e.error?.message || e);
        throw e;
      })
    );
  }
}
